import React from 'react';
// Images
import MainImage1 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-ass-sexy.jpg';
// Data
import { fanSitesArray } from '../../utils/data/FansiteData';
// Components
import CallToActionOne from '../cta/CallToActionOne';
import FollowMeOnCta from '../socialMedia/FollowMeOnCta';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Constants
import {
  I_WANT_CLIPS_URL,
  LOYALFANS_URL,
  SEXT_PANTHER_URL,
} from '../../utils/Constants';

function FansitesPageMainContainer() {
  return (
    <main role='main' className='sm:pt-4 lg:pt-12'>
      {/* Info */}
      <section className='container mx-auto mt-8 mb-8 py-6 px-8 lg:px-16'>
        {/* Main Content with Image */}
        <div className='grid lg:grid-cols-[2fr_1fr] gap-6 lg:gap-8 items-center'>
          {/* Text Content */}
          <article className='grid gap-y-6 order-2 lg:order-1'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6'>
              {/* Large screen */}
              <div className='hidden md:grid items-center'>
                <h3 className='text-3xl font-titleFont text-colour7 tracking-widest'>
                  Exclusive Content
                </h3>
              </div>
              {/* Phone screen */}
              <div className='grid md:hidden items-center'>
                <h3 className='text-2xl font-titleFont text-colour7 tracking-widest'>
                  Exclusive <br /> Content
                </h3>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-2 bg-colour7'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            <div>
              <p className='text-lg leading-relaxed opacity-80'>
                <strong>My exclusive content</strong>{' '} is your gateway to mind-warping control,
                eerie elegance, and irresistible humiliation.
              </p>
              <p className='text-lg leading-relaxed opacity-80'>
                Since 2015, I’ve been crafting scenes soaked in dominance and
                dripping with intensity. Whether you crave brutal power play,
                mental ruin, or slow, seductive torment, you’ll find it here —
                every clip is a masterpiece of control and corruption.
              </p>
              <p className='text-lg leading-relaxed opacity-80'>
                Indulge in My world across{' '}
                <a
                  href={I_WANT_CLIPS_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-colour7 underline'
                >
                  {' '}
                  iWantClips
                </a>
                ,
                <a
                  href={SEXT_PANTHER_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-colour7 underline'
                >
                  {' '}
                  SextPanther
                </a>
                , and{' '}
                <a
                  href={LOYALFANS_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-colour7 underline'
                >
                  LoyalFans
                </a>
                . Dive in. Tribute properly. And remember — obedience is just
                the beginning.
              </p>
            </div>
          </article>

          {/* Image */}
          <div className='grid justify-center mt-4 lg:mt-0 order-1 lg:order-2'>
            <img
              src={MainImage1}
              alt='Liyah Minx - Clips & Exclusive Content'
              className='w-full max-w-md h-full rounded neon_shadow'
              loading='lazy'
            />
          </div>
        </div>

        {/* Clipstores Section */}
        <section className='mt-16 lg:mt-24 grid'>
          <section className='grid my-auto lg:order-last'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6 pb-4'>
              {/* Large screen */}
              <div className='hidden md:grid items-center'>
                <h4 className='text-3xl font-titleFont text-colour7 tracking-widest'>
                  Fansites
                </h4>
              </div>
              {/* Phone screen */}
              <div className='grid md:hidden items-center'>
                <h4 className='text-2xl font-titleFont text-colour7 tracking-widest'>
                  Fansites
                </h4>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-2 bg-colour7'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            <section className='grid lg:grid-cols-2'>
              <div>
                <p className='text-lg text-center lg:text-left opacity-80 leading-relaxed'>
                  Explore my exclusive collection of elite BDSM clips — where
                  raw power, seductive dominance, and unfiltered intensity
                  collide. Each video is crafted to captivate, entice, and leave
                  a lasting impression.
                </p>
                <div className='mx-auto grid justify-center lg:justify-start'>
                  <ul className='list-none mt-4 space-y-3 px-4 text-center lg:text-left text-lg'>
                    <li>
                      Female Domination Clips — from commanding verbal
                      humiliation to full control
                    </li>
                    <li>
                      Fetish & Power Play — tailored kinks, psychological play,
                      and irresistible submission
                    </li>
                    <li>
                      Custom Scenarios — created to indulge your deepest
                      fantasies
                    </li>
                    <li>
                      High-Quality Visuals — professionally edited with
                      crystal-clear sound
                    </li>
                  </ul>
                </div>
              </div>

              <div className='py-6 grid md:grid-cols-3 gap-y-8'>
                {fanSitesArray.map((site, index) => (
                  <a
                    key={index}
                    href={site.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='px-6 grid grid-rows-rev rounded-lg transition-transform transform hover:scale-105'
                  >
                    {site.logo && !site.icon ? (
                      <img
                        src={site.logo}
                        alt={`${site.name} Logo`}
                        className='h-16 brightness-125 mx-auto'
                        loading='lazy'
                      />
                    ) : site.icon && site.logo ? (
                      <div className='flex items-center justify-center gap-3'>
                        {/* Check if site.icon is a string or a React icon */}
                        {typeof site.icon === 'string' ? (
                          <img
                            src={site.icon}
                            alt={`${site.name} Icon`}
                            className='h-10'
                            loading='lazy'
                          />
                        ) : (
                          <span className='text-4xl text-colour1'>
                            {site.icon}
                          </span>
                        )}
                        <img
                          src={site.logo}
                          alt={`${site.name} Logo`}
                          className='h-16 brightness-125'
                          loading='lazy'
                        />
                      </div>
                    ) : site.icon && site.textOnly ? (
                      // Special case: Telegram (Icon + Text)
                      <div className='grid w-fit gap-4 justify-center mx-auto grid-flow-col items-center'>
                        <div>
                          {/* Check if site.icon is a string or a React icon */}
                          {typeof site.icon === 'string' ? (
                            <img
                              src={site.icon}
                              alt={`${site.name} Icon`}
                              className='h-10'
                              loading='lazy'
                            />
                          ) : (
                            <span className='text-4xl text-colour1'>
                              {site.icon}
                            </span>
                          )}
                        </div>
                        <div>
                          <span className='text-2xl lg:text-4xl uppercase text-center mt-2 text-colour1 font-semibold'>
                            {site.name}
                          </span>
                        </div>
                      </div>
                    ) : site.icon ? (
                      <div className='grid justify-center h-fit'>
                        {/* Check if site.icon is a string or a React icon */}
                        {typeof site.icon === 'string' ? (
                          <img
                            src={site.icon}
                            alt={`${site.name} Icon`}
                            className='h-10'
                            loading='lazy'
                          />
                        ) : (
                          <div className='grid items-center'>
                            <span className='text-4xl text-colour7'>
                              {site.icon}
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='text-center text-colour1 uppercase text-4xl font-bold'>
                        {site.name}
                      </div>
                    )}
                    <div className='text-center pt-4'>
                      <p className='text-2xl font-titleFont text-colour1'>
                        {site.name}
                      </p>
                    </div>
                  </a>
                ))}
              </div>
            </section>
          </section>
        </section>
      </section>

      {/* Cta */}
      <CallToActionOne />

      {/* Follow me */}
      <div className='py-12'>
        <FollowMeOnCta />
      </div>

      {/* Social cta */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default FansitesPageMainContainer;
